export default {
  tableHeader: 'Sygnały aktywów',
  showHidden: 'Pokaż ukryte sygnały aktywów',
  overFlowMenu: {
    tooltip: 'Dodatkowe funkcje',
    export: 'Eksportuj ustawienia czujnika',
    import: 'Importuj ustawienia czujnika',
  },
  placeholder: {
    meaningId: 'Wybierz znaczenie',
    meaningInstanceNumber: 'Numer instancji',
  },
};
